module.exports = __webpack_public_path__ + "img/card_icon_five.6813babc.png";